module.exports = __webpack_public_path__ + "static/img/aRZ_pic09.adab88e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aRZ_pic09.jpg
// module id = GeWh
// module chunks = 5